<template>
  <div>
    <div>
      
      <editLogForm
        v-if="this.toggleEditLogForm == true"
        :log="this.CurrentlyEditingLog"
        :propertyid="this.propertyid"
        v-on:updated-log="updateLogLocally($event)"
        v-on:close-EditLogForm="toggleEditLogFormMethod()"
      />
      <DeleteLogForm
        v-if="this.toggleDeleteLogForm == true"
        :log="this.CurrentlyDeletingLog"
        v-on:delete-log-locally="deleteLogLocally($event)"
        v-on:close-DeleteLogForm="toggleDeleteLogFormMethod()"
      />
    </div>

    <div
      v-if="
        this.toggleCreateLogForm == false"
      class="form-container"
    >
      <div class="log-pad">
        <div v-if="this.loglist.length == 0" style="padding:5%; color:gray;">
          <h1>
            You dont have any notes in this asset yet.
          </h1>
        </div>
        <div class="log-card-parent" v-for="log in this.loglist" :key="log.logid">
        <el-card style="display:inline-block; flex-grow: 1;" >

          <div class="log" style=" display: flex;
              flex-direction: row;">
            <el-avatar :size="45" :src="log.userspicurl" style="min-width:45px; margin-right:10px;"></el-avatar>
            <div style="width:100%; overflow: hidden;">
              <div
                style="width:100%; display: flex;
                  justify-content: space-between;
                   color:#c0c0c0;"
              >
                <h4 style="width:90%; margin-top:0px">
                  <span style="color:black;">{{ log.firstname }} {{ log.lastname }}</span>
                  -
                  {{
                  log.logdate
                  | moment("timezone", $timeZone, "MMM DD YYYY hh:mm A")
                  }}
                </h4>
                <div class="dropdown" style="left:0;">
                  <el-dropdown
                   trigger="click"
                    class="tst-note-options-menu"
                    v-if="log.canedit == true || log.candelete == true || log.userid == user.userid"
                  >
                    <el-button type="text">
                      <i class="el-icon-s-operation"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="log.userid == user.userid || log.canedit == true">
                        <el-button style="color: unset" class="tst-edit-note-option" @click.native="toggleEditLogFormMethod(log)" type="text">
                          <i class="fa fa-edit mt-2"></i>Edit Note
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="
                          log.userid == user.userid || log.candelete == true
                        "
                      >
                        <el-button
                        style="color: unset"
                          class="btn btn-icon-only text-light tst-delete-note-option"  type="text"
                          @click.native="toggleDeleteLogFormMethod(log)"
                        >
                          <i class="fa fa-trash mt-2"></i> Delete Note
                        </el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>

              <div
                class="log-note"
                style="background-color: #EBEFF2; border-radius:3px; padding:1%; overflow-wrap: break-word"
              >
                {{ log.note }}
                <br />
                <br />

                <div class="logimageholder">
                  <el-image
                    v-for="img in log.imageurl"
                    :key="img"
                    :preview-src-list="log.imageurl"
                    :src="img"
                    fit="contain"
                    style="width:200px; height:200px; background-position: center center;
                        background-repeat: no-repeat; padding:1%;"
                  >
                    <div slot="placeholder" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                    <!-- <div slot="error" class="image-slot">
                      <i class="el-icon-error"></i>
                    </div>-->
                  </el-image>
                </div>
                <div v-for="file in log.files" :key="file.fileid">
                  <el-row>
                    <el-button
                      type="primary"
                      size="mini"
                      @click.native="downloadFile(file.fileurl)"
                      icon="fas fa-file-download"
                      circle
                    ></el-button>
                    {{ file.filename }}
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </el-card>

        <div>
            <i v-if="log.logFailed == true"  style=" display:inline-block;color: red;" class="fas fa-exclamation-circle"></i>
        </div>
        </div>
           <div id="content"></div>
        
      </div>
<div class="add-log">

<createLogForm
        v-if="this.cancreatenote == true"
        v-on:add-log-locally="addLogLocally($event)"
        v-on:local-log-return-data="updateLogLocally($event)"
                v-on:action-in-addbox="adjustNotepadSize($event)"
        v-on:log-upload-failed="handleLogFailed($event)"
        :currentissueid="this.issueid"
        :propertyid="this.propertyid"

     />

</div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import CreateLogForm from "@/components/logs/CreateLogForm.vue";
import EditLogForm from "@/components/logs/EditLogForm.vue";
import DeleteLogForm from "@/components/logs/DeleteLogForm.vue";
import EventBus from '@/services/EventBus.js';
import fab from "vue-fab";

export default {
  props: {
    loglist: Array,
    logheaders: Object,
    propertyid: String,
    issueid: String
  },
  components: {
    CreateLogForm,
    EditLogForm,
    DeleteLogForm,
    fab
  },
  data() {
    return {
      toggleCreateLogForm: false,
      toggleEditLogForm: false,
      toggleDeleteLogForm: false,
      CurrentlyEditingLog: {},
      CurrentlyDeletingLog: {},
      cancreatenote: this.logheaders.cancreatenote
    };
  },
  created() {},
   
  mounted() {
  
    this.scrollToBottom();
    this.$root.$on("close-form", () => this.closeFormsFromBackButton());
          EventBus.$on('log-from-signalr', (log) =>   this.loglist.push(log));

  },
  updated() {
   // this.scrollToBottom();
    this.cancreatenote = this.logheaders.cancreatenote;
  },

  methods: {
    adjustNotepadSize($event){
     var logPad = document.getElementsByClassName("log-pad")[0];

     logPad.style = `margin-bottom: ${$event}px`
    },

    downloadFile(fileurl) {
      location.href = fileurl;
    },
    closeFormsFromBackButton() {
      console.log("close forms from back button is closing");
      this.toggleCreateLogForm = false;
      this.toggleEditLogForm = false;
      this.toggleDeleteLogForm = false;
    },
    toggleCreateLogFormMethod() {
      this.toggleCreateLogForm = !this.toggleCreateLogForm;
      this.changeBackButton();
    },
    changeBackButton() {
      this.$root.$emit("form-toggled");
    },
    toggleEditLogFormMethod(log) {
      this.toggleEditLogForm = !this.toggleEditLogForm;
      this.CurrentlyEditingLog = log;
      this.changeBackButton();
    },
    toggleDeleteLogFormMethod(log) {
      this.toggleDeleteLogForm = !this.toggleDeleteLogForm;
      this.CurrentlyDeletingLog = log;
      this.changeBackButton();
    },

    addLogLocally($event) {
      console.log("add new log locally is firing");
      this.loglist.push($event);
      
      this.$nextTick(function () {
        this.scrollToBottom();
      })
    },
    updateLogLocally($event) {
      console.log("update locally is firing");
      this.$set(this.loglist, this.loglist.indexOf($event[0]), $event[1]);
    },
    deleteLogLocally($event) {
      this.$delete(this.loglist, this.loglist.indexOf($event));
    },
    scrollToBottom() {
      var elmnt = document.getElementById("content");
      elmnt.scrollIntoView();
    },
    handleLogFailed($event){
      var indexOfLog = this.loglist.indexOf($event);
    $event.logFailed = true;
    this.$set(this.loglist, indexOfLog, $event);

    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  }
};
</script>

<style scoped>

.form-container{
  flex-direction: column;
  height: calc(100vh - 101px);
}

.log-card-parent {
  display: flex;
  align-items: center;
  width: 100%;
}
.logimageholder {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.log-note {
  word-wrap: break-word;
  width: 90%;
}

.log-pad{
  flex-grow: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 20px 2%;
    margin-bottom: 64px;
}



@media (min-width: 320px) and (max-width: 979px) {

  .log-pad{
    width: unset;
    padding: unset;
  }

 

  .log-card-parent {
    width: 90%;
    margin-left: 14px;
    display: flex;
  }
  .log-note {
    word-wrap: break-word;
    width: 80%;
  }
  .dropdown {
    width: 80px;
  }
}
</style>
